/* Column renderers shared by the points-admin descriptors and /document.
 *
 * This file used to carry ~70 exports for the pre-redesign EntityTable screens. All but six lost
 * their last caller when /route, /dashboard, /k-form and the visit tabs went; the rest is deleted
 * rather than kept as a second, drifting copy of what `component/table-cells.js` already draws.
 *
 * The person/network cells now go through `PersonCell` for the reason CLAUDE.md gives: an avatar
 * is the subject's INITIALS with the photo preferred, never a generic glyph. These six were the
 * last renderers in the app still emitting a Material Symbols `person`/`store` span, which is what
 * made the points-admin tables look like a different product from every other table.
 *
 * Signature is `(value, item)` — the descriptor column contract — except `dateTimeCreated`, which
 * takes the record.
 */
import React from "react";

import dayjs from "./dayjs";
import { PersonCell } from "../component/table-cells";
import { MOVEMENTS } from "../config/const";

export function locality(i, item) {
  return <span>{item.locality?.name}</span>;
}

export function movement(i, item) {
  return <span> {item && MOVEMENTS[item.movement]}</span>;
}

export function userName(i, item) {
  return <PersonCell user={item} />;
}

export function createdByInfo(i, item) {
  return item.created_by ? <PersonCell user={item.created_by} /> : null;
}

export function networkName(i, item) {
  return item.network ? <PersonCell name={item.network.name} photo={item.network.image} /> : null;
}

export function dateTimeCreated(item) {
  if (!item || !item.created) return "—";
  // Humanized, unambiguous format, e.g. "20 Jul 2026, 14:30".
  return dayjs(item.created).format("DD MMM YYYY, HH:mm");
}

/** Currency is not modelled anywhere in the app, so every order/return total renders as a bare
    number — same rule and same output as `visit/sections.js`'s own `money` (kept local there
    rather than imported, since that module drags in `LeafletMap` and `models/photo-review`). */
export function formatMoney(value) {
  return value === null || value === undefined || value === "" ? "" : Number(value).toFixed(2);
}
